import { render, staticRenderFns } from "./TaxInfo.vue?vue&type=template&id=515025fe&scoped=true&"
import script from "./TaxInfo.vue?vue&type=script&lang=js&"
export * from "./TaxInfo.vue?vue&type=script&lang=js&"
import style0 from "./TaxInfo.vue?vue&type=style&index=0&id=515025fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515025fe",
  null
  
)

export default component.exports